export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_download') || '下载',
    icon: 'el-icon-download',
    menuType: 'download',
    divided: true,
    allow: 'X',
    disabled: ({ processFlag }) => processFlag !== 'Y',
  },
  {
    text: that.$l('menu_text_preview') || '预览',
    icon: 'el-icon-full-screen',
    menuType: 'preview',
    allow: 'P',
    disabled: ({ processFlag }) => processFlag !== 'Y',
  },
  {
    text: that.$l('menu_text_delete') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    disabled: ({ processFlag }) => !['N', 'K'].includes(processFlag),
  },
]
